import React from 'react';
import LeadsTable from "components/Leads/LeadsTable";

const Leads = () => {
    return (
        <LeadsTable/>
    );
}

export default Leads;